import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemoryState } from './state/memory.state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([MemoryState]), CommonModule],
})
export class MemoryModule {}
